import PropTypes from 'prop-types'
import React from 'react'
import ForwardIcon from '@mui/icons-material/Forward'

const Forward = ({ className }) => <ForwardIcon className={className} />

export default Forward

Forward.propTypes = {
  className: PropTypes.string
}
